<template>
  <b-section-loader :loading="$loading.isLoading('analyzeReportResult')">
    <div class="d-flex ga-3 flex-wrap">
      <printed-form-result-item
        :generated-printed-form="printedFormResult.reportAnalyze"
        label="Аналіз звітності"></printed-form-result-item>
      <printed-form-result-item
        :generated-printed-form="printedFormResult.reportFinancialAnalyze"
        label="Фінансовий аналіз звітів"></printed-form-result-item>
      <printed-form-result-item
        :generated-printed-form="printedFormResult.reportDetail"
        label="Деталізація пакетів"></printed-form-result-item>
      <printed-form-result-item
        :generated-printed-form="printedFormResult.debtorDuplicate"
        label="Дублікати боржників"></printed-form-result-item>
      <debtor-chronology-result-item
        :debtor-chronology="printedFormResult.debtorChronology"
        label="Хронологія боржника"></debtor-chronology-result-item>
    </div>
    <div
      v-if="!Object.values(printedFormResult).filter(Boolean).length"
      class="text-disabled text-center mt-5">
      Сформовані звіти зберігаються тут протягом 1 години
    </div>
  </b-section-loader>
</template>

<script lang="ts">
import { PropType } from 'vue'
import { PrintedFormResult } from '@/utils/types'
import PrintedFormResultItem from './PrintedFormResultItem.vue'
import DebtorChronologyResultItem from './DebtorChronologyResultItem.vue'

export default {
  name: 'PrintedFormResult',
  components: { PrintedFormResultItem, DebtorChronologyResultItem },
  props: {
    printedFormResult: {
      type: Object as PropType<PrintedFormResult>,
    },
  },
}
</script>

<style scoped lang="scss"></style>
